export default "__VITE_ASSET__D771KdSs__"